<template>
  <form v-bind="$attrs" @submit.prevent="onSubmit">
    <slot />
  </form>
</template>

<script setup>
  defineOptions({ name: "AppForm", inheritAttrs: false })

  defineProps({
    // state is accepted but not used for validation (no schema in current usage)
    // kept for API compatibility with UForm
    state: {
      type: Object,
      default: () => ({}),
    },
  })

  const emit = defineEmits(["submit"])

  const onSubmit = (event) => {
    emit("submit", event)
  }
</script>
